import React from "react";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import Home from "./Component/Home";

const App = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default App;
